module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0027.81709bcb.jpg";